module.exports = __webpack_public_path__ + "img/perfume.18246d78.gif";